<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; Exit Form</h5>
      </div>
<div id="mainContent" class="container" style="margin-bottom: 20px;">
  <div class="row pt-2">
    <div class="col-md-12" style="text-align: center">
      <span class="bg-theme-title">ANNEXURE I</span>
    </div>
  </div>
<hr>
  <div class="row pt-2">
    <div class="col-md-12" style="text-align: center">
      <span class="bg-theme-title">EXIT INTERVIEW FORM</span>
    </div>
  </div>
  <div class="modal-body mt-2">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label" *ngIf="!showArticleDataFromSummary">Employee Name</label>
            <label class="col-form-label" *ngIf="showArticleDataFromSummary">Article Name</label>
          </div>
          <div class="col-md-6">
            <!-- <input
                id="empName"
                name="empName"
                type="text"
                class="form-control form-control-xs"
                disabled
                [(ngModel)]="exitFormModel.user.firstName"
                /> -->
            <span>{{empFirstName}} {{empMiddleName}} {{empLastName}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label"> Separation date</label>
          </div>
          <div class="col-md-6">
            <div class="input-group">
              <input id="seperationDate" name="seperationDate" class="form-control form-control-xs"
                placeholder="dd/mm/yyyy" ngbDatepicker #seperationDate="ngbDatepicker"
                (dateSelect)="onSeperationDateSelect()" [(ngModel)]="selectedSeperationDate" [minDate]="currentDate" [disabled]="disableFieldsAfterEdit"/>
              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="seperationDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6" *ngIf="!showArticleDataFromSummary">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label">Employee ID</label>
          </div>
          <div class="col-md-6">
            <!-- <input
            id="empID"
            name="empID"
            type="text"
            class="form-control form-control-xs"
            [(ngModel)]="exitFormModel.user.id"
            disabled/> -->
            <span>{{empID}}</span>
          </div>
        </div>
      </div>

      <div class="col-md-6" *ngIf="showArticleDataFromSummary">
        <div class="row">
          <label class="col-md-4 col-form-label">Partner
          </label>
          <div class="col-md-6">
            <select ngbAutofocus class="form-control form-control-xs" id="partner" name="partner"
              [(ngModel)]="exitFormModel.partner" (change)="onPartnerChange()" [disabled]="disableFieldsAfterEdit">
              <option [ngValue]="null">Select Partner Name</option>
              <option *ngFor="let partner of partnerList" [ngValue]="partner">
                {{ partner.firstName }} {{ partner.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label">Eligible for Rehire</label>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-0" style="margin-top: -2%">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="eligibleForRehire" id="eligibleForRehire" [disabled]="disableFieldsAfterEdit"
                  [value]="true" [(ngModel)]="exitFormModel.eligibleForRehire" />
                <label class="col-form-label" style="font-weight: 400">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="eligibleForRehire" id="eligibleForRehire" [disabled]="disableFieldsAfterEdit"
                  [value]="false" [(ngModel)]="exitFormModel.eligibleForRehire" />
                <label class="col-form-label" style="font-weight: 400">No</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!showArticleDataFromSummary">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label">Job Title</label>
          </div>
          <div class="col-md-6">
            <input id="jobTitle" name="jobTitle" type="text" class="form-control form-control-xs"
              [(ngModel)]="exitFormModel.jobTitle" [disabled]="disableFieldsAfterEdit"/>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label">Job Code</label>
          </div>
          <div class="col-md-6">
            <input id="jobCode" name="jobCode" type="text" class="form-control form-control-xs"
              [(ngModel)]="exitFormModel.jobCode" [disabled]="disableFieldsAfterEdit"/>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12" style="text-align: center">
        <span class="bg-theme-title">REASON FOR SEPARATION</span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <span class="bg-theme-title" style="text-decoration:underline;"> Voluntary</span>
      </div>
      <div class="col-md-6">
        <span class="bg-theme-title" style="text-decoration:underline;">InVoluntary</span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.dissatisfication" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Dissatisfication with present Articleship profile</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.positionEliminated" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Position Eliminated</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.anotherPosition" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Another Position</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.attendance" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Attendance</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.personalReason" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Personal Reason</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.violationOfFirmPolicy" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Violation of Firm Policy</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.relocation" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Relocation</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.layOff" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">lay Off</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.retirement" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Retirement</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.reorganization" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Reorganization</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.furtherStudies" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Further Studies</label>
      </div>
      <div class="col-md-6">
        <input type="checkbox" [(ngModel)]="exitFormModel.otherInvoluntary" [disabled]="disableFieldsAfterEdit"/>
        <label class="col-form-label ml-2">Other</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <select class="form-control form-control-xs mt-1" [(ngModel)]="exitFormModel.otherVoluntary" [disabled]="disableFieldsAfterEdit">
              <option value="">Select</option>
              <option value="Other Voluntary">Other</option>
              <option value="For Better Prospect">For Better Prospect</option>
            </select>
          </div>
          <div class="col-md-6">
            <input type="text" id="valDescription" name="valDescription" class="form-control form-control-xs"
              [(ngModel)]="exitFormModel.otherVoluntaryDesc" [disabled]="disableFieldsAfterEdit">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <input type="text" id="valDescription" name="valDescription" class="form-control form-control-xs"
              [(ngModel)]="exitFormModel.otherInvoluntaryDesc" [disabled]="disableFieldsAfterEdit">
          </div>
          <div class="col-md-6"></div>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label" *ngIf="!showArticleDataFromSummary">Employee Comments :</label>
          <label class="col-form-label" *ngIf="showArticleDataFromSummary">Article Comments :</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="3" class="form-control form-control-xs" id="empComments"
            name="empComments" [(ngModel)]="exitFormModel.employeeComments" [disabled]="disableFieldsAfterEdit">
      </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"> Interviewer Comments :</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="3" class="form-control form-control-xs"
            id="InterviewerComments" name="InterviewerComments" [(ngModel)]="exitFormModel.interviewerComments"
            [disabled]="disableInterviewerFields">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label mr-2">Employee Signature</label>
        <input type="checkbox" [(ngModel)]="exitFormModel.employeeSignature" [disabled]="disableFieldsAfterEdit"/>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-1">
            <label class="col-form-label">Date</label>
          </div>
          <div class="col-md-5 mt-2">
            <div class="input-group">
              <input id="empSignDate" name="empSignDate" class="form-control form-control-xs" placeholder="dd/mm/yyyy"
                ngbDatepicker #empSignDate="ngbDatepicker" (dateSelect)="onEmpSignDateSelect()"
                [(ngModel)]="selectedEmpSignDate" [disabled]="disableFieldsAfterEdit"/>
              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="empSignDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label mr-2">Interviewer Signature</label>
        <input type="checkbox" [(ngModel)]="exitFormModel.interviewerSignature" [disabled]="disableInterviewerFields" />
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-1">
            <label class="col-form-label">Date</label>
          </div>
          <div class="col-md-5 mt-2">
            <div class="input-group">
              <input id="intSignDate" name="intSignDate" class="form-control form-control-xs" placeholder="dd/mm/yyyy"
                ngbDatepicker #intSignDate="ngbDatepicker" (dateSelect)="onInterviewerSignDateSelect()"
                [(ngModel)]="selectedInterviewerDate" [disabled]="disableInterviewerFields" />
              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="intSignDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12" style="text-align: center">
        <span class="bg-theme-title">QUESTIONNAIRE</span>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"> 1.What are your primary reasons for leaving?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion1" name="answerOfQuestion1" [(ngModel)]="exitFormModel.answerOfQuestion1"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">2.What did you find most satisfying about your Job?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion2" name="answerOfQuestion2" [(ngModel)]="exitFormModel.answerOfQuestion2"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">3.What did you find most frustating about your Job?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion3" name="answerOfQuestion3" [(ngModel)]="exitFormModel.answerOfQuestion3"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"> 4.Did any Firm policy or procedure(or any other obstacle) make your Job more
            difficult?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion4" name="answerOfQuestion4" [(ngModel)]="exitFormModel.answerOfQuestion4"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">5.Would you consider returning to this Firm in the future?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion5" name="answerOfQuestion5" [(ngModel)]="exitFormModel.answerOfQuestion5"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">6.Would you recommend this Firm to a friend as a good place to work?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion6" name="answerOfQuestion6" [(ngModel)]="exitFormModel.answerOfQuestion6"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">7.Is there anything the Firm could have done to retain you?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion7" name="answerOfQuestion7" [(ngModel)]="exitFormModel.answerOfQuestion7"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">8.Did you receive sufficient feedback about your performance between
            reviews?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion8" name="answerOfQuestion8" [(ngModel)]="exitFormModel.answerOfQuestion8"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"> 9.Did you receive enough training to do your Articleship effectively?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion9" name="answerOfQuestion9" [(ngModel)]="exitFormModel.answerOfQuestion9"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">10.Did this Firm help you to fulfill your career goals?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion10" name="answerOfQuestion10" [(ngModel)]="exitFormModel.answerOfQuestion10"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label"> 11.Do you have any tips to help us find your replacement?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion11" name="answerOfQuestion11" [(ngModel)]="exitFormModel.answerOfQuestion11"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">12.What would you improve to make our workplace better?</label>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion12" name="answerOfQuestion12" [(ngModel)]="exitFormModel.answerOfQuestion12"
            [disabled]="disableFieldsAfterEdit">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="">
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label">13.Any other comments?</label>
        </div>
        <div class="col-md-6"></div>
      </div>

      <div class="row">
        <div class="col-md-9">
          <textarea style="overflow: auto; resize: none" rows="2" class="form-control form-control-xs"
            id="answerOfQuestion13" name="answerOfQuestion13" [(ngModel)]="exitFormModel.answerOfQuestion13">
       </textarea>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-5"></div>
      <div class="col-md-2" *ngIf="showSaveButton">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="saveClick()">
          Save
        </button>
      </div>
      <div class="col-md-2" *ngIf="!showSaveButton">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="updateClick()">
          Update
        </button>
      </div>
      <div class="col-sm-2">
        <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="cancleClick()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
</div>